require('../../scss/frontend/timeline.scss');

document.addEventListener("DOMContentLoaded", function (event) {
    const wrapperElement = document.querySelector('#dcs-timeline-wrapper');

    // Function to determine timeline orientation based on viewport height
    function setTimelineOrientation() {
        const verticalTimeline = document.querySelector('#dcs-timeline.vertical');
        const horizontalTimeline = document.querySelector('#dcs-timeline.horizontal');

        // Check if viewport height is less than 850px
        if (window.innerHeight >= 850 && verticalTimeline) {
            // Convert vertical to horizontal
            verticalTimeline.classList.remove('vertical');
            verticalTimeline.classList.add('horizontal');
            console.log('Switched to horizontal timeline due to small viewport height');
            initHorizontalTimeline();
        } else if (window.innerHeight < 850 && horizontalTimeline) {
            // If viewport height is restored, convert back to vertical
            horizontalTimeline.classList.remove('horizontal');
            horizontalTimeline.classList.add('vertical');
            console.log('Switched to vertical timeline due to sufficient viewport height');
            initVerticalTimeline();
        } else {
            // Initial setup based on current classes
            if (document.querySelector('#dcs-timeline.horizontal')) {
                initHorizontalTimeline();
            } else if (document.querySelector('#dcs-timeline.vertical')) {
                initVerticalTimeline();
            }
        }
    }

    // Initialize horizontal timeline functionality
    function initHorizontalTimeline() {
        const containerElement = document.querySelector('#dcs-timeline.horizontal');
        const scrollableElement = document.querySelector('#dcs-timeline.horizontal > div');

        if (!containerElement || !scrollableElement) return;

        console.log('Initializing horizontal timeline');

        const containerWidth = containerElement.scrollWidth;

        wrapperElement.style.height = (containerWidth - window.innerWidth + containerElement.getBoundingClientRect().height) + 'px';
        const minScroll = 0;
        const maxScroll = containerWidth - window.innerWidth;

        window.onscroll = (e) => {
            const position = 120 - wrapperElement.getBoundingClientRect().y;
            const containerSticky = position < minScroll ? 'top' : (position < maxScroll ? 'fixed' : 'bottom');
            const scrollablePosition = -(position < minScroll ? minScroll : (position < maxScroll ? position : maxScroll));

            switch (containerSticky) {
                case 'top':
                    containerElement.style.position = 'relative';
                    containerElement.style.top = 'unset';
                    break;
                case 'fixed':
                    containerElement.style.position = 'fixed';
                    containerElement.style.top = '120px';
                    break;
                case 'bottom':
                    containerElement.style.position = 'relative';
                    containerElement.style.top = `${maxScroll}px`;
                    break;
            }
            scrollableElement.style.transform = `translateX(${scrollablePosition}px)`;
        };
    }

    // Initialize vertical timeline functionality
    function initVerticalTimeline() {
        const containerElement = document.querySelector('#dcs-timeline.vertical');
        const scrollableElement = document.querySelector('#dcs-timeline.vertical > div');
        const floorElement = document.querySelector('#floor');
        const subfloorElement = document.querySelector('#subfloor');

        if (!containerElement || !scrollableElement) return;

        console.log('Initializing vertical timeline');

        if (floorElement && subfloorElement) {
            floorElement.style.position = 'fixed';
            subfloorElement.style.marginTop = floorElement.getBoundingClientRect().height + 'px';
        }

        const containerHeight = containerElement.scrollHeight;

        wrapperElement.style.height = (containerHeight - window.innerHeight + 100 + containerElement.getBoundingClientRect().height) + 'px';
        const minScroll = 0;
        const maxScroll = containerHeight - window.innerHeight + 150;

        window.onscroll = (e) => {
            const position = 120 - wrapperElement.getBoundingClientRect().y;
            const containerSticky = position < minScroll ? 'top' : (position < maxScroll ? 'fixed' : 'bottom');
            const scrollablePosition = -(position < minScroll ? minScroll : (position < maxScroll ? position : maxScroll));

            switch (containerSticky) {
                case 'top':
                    containerElement.style.position = 'relative';
                    containerElement.style.top = 'unset';
                    break;
                case 'fixed':
                    containerElement.style.position = 'fixed';
                    containerElement.style.top = '120px';
                    break;
                case 'bottom':
                    containerElement.style.position = 'relative';
                    containerElement.style.top = `${maxScroll}px`;
                    break;
            }

            if (floorElement) {
                floorElement.style.top = (containerElement.getBoundingClientRect().top + containerElement.getBoundingClientRect().height) + 'px';
            }
            scrollableElement.style.transform = `translateY(${scrollablePosition}px)`;
        };
    }

    // Initial setup
    setTimelineOrientation();

    // Also check when window resizes
    window.addEventListener('resize', setTimelineOrientation);
});